import ReactComponent from '../../app/ReactComponent'
import {Button, Drawer, Image, Spin} from 'antd'
import React from 'react'
import {Link} from 'react-router-dom'
import {ReactComponent as Logo} from '../../image/logo-desktop.svg'
import {NotificationItem} from './NotificationItem'
import AvatarManSVG from "../../image/dashboard/avatar_muz.svg"
import AvatarWomanSVG from "../../image/dashboard/avatar_zena.svg"
import {MessagesResource} from '../../resources/MessagesResource'
import {prettyDate, relativeTime} from '../../helpers/utils'
import dayjs from 'dayjs'

const closeIcon = <Image preview={false} src={require('../../image/Close@2x.png')} />

export class NotificationSidenav extends ReactComponent {
  state = {
    notifications: [],
    loading: false,
    isNotificationsLoaded: false,
  }
  async componentDidMount() {

  }

  async componentDidUpdate (prevProps) {
    if (prevProps.visible !== this.props.visible && this.state.isNotificationsLoaded === false) {

      await this.getNotifications()

    }
  }

  getNotifications = async () => {
    try {

      void this.updateState({loading: true})

      let res = await this.$app.$store('messages').getNotifications(5)

      void this.updateState({
        notifications: res.notifications.map(item => ({
          title: item.title,
          message: item.html_body,
          time: prettyDate(item.send_time),
          relativeTime: relativeTime(item.send_time),
          buttonLink: item.button_link,
          buttonText: item.button_text
        })),
        isNotificationsLoaded: true,
        loading: false
      })

    } catch (e) {
      console.error(e)
    }
  }

  close = () => {
    this.scrollToTop()
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {
    const notificationLogo = <Link to={"/"} onClick={this.close}><Logo/></Link>

    return (
      <Drawer
        className="menu-drawer notification-drawer"
        title={notificationLogo} 
        placement="right" 
        onClose={this.close} 
        open={this.props.visible} 
        closeIcon={closeIcon}
      >
        <Spin spinning={this.state.loading} size={'large'}>
        <div style={{display:'flex', flexDirection:"column", gap: '16px'}}>
          {this.state.notifications.length === 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px 20px',
              textAlign: 'center',
              color: '#999'
            }}>
              <p style={{fontSize: '16px', marginBottom: '8px'}}>Žádné notifikace</p>
              <p style={{fontSize: '14px'}}>Momentálně nemáte žádné nové zprávy</p>
            </div>
          ) : (
            this.state.notifications.map((notification, index) => (
              <NotificationItem
                key={index}
                title={notification.title}
                message={notification.message}
                time={notification.time}
                relativeTime={notification.relativeTime}
                buttonLink={notification.buttonLink}
                buttonText={notification.buttonText}
              />
            ))
          )}
        </div>
        </Spin>
        <Link to="/notifications" onClick={this.close} className="ml-3 mt-2">
          <span>
            Zobrazit vše
          </span>
        </Link>
      </Drawer>
    )
  }
}
